<template>
  <div class="item-wrapper">
    <div class="columns">
      <div class="column is-3">
        <p class="item-text">
          <span class="item-bold-text"> {{ item.articulo.id }} </span>
        </p>
      </div>
      <div class="column is-3">
        <p class="item-text">
          STK:
          <span class="item-bold-text is-pulled-right">
            {{ item.stock }}
          </span>
        </p>
      </div>
      <div class="column is-3">
        <p class="item-text">
          CNT:
          <span class="item-bold-text is-pulled-right">
            {{ item.cantidadContada }}
          </span>
        </p>
      </div>
      <div class="column is-3">
        <p class="item-text">
          DIF:
          <span class="item-bold-text is-pulled-right">
            {{ diferencia }}
          </span>
        </p>
      </div>
    </div>
    <div class="item-description-wrapper">
      <span class="item-description">
        {{ item.articulo.descripcion }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparadorArticulo',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    diferencia() {
      return this.item.cantidadContada - this.item.stock
    }
  }
}
</script>

<style lang="scss" scoped>
.columns {
  margin-bottom: 0;
}

.column {
  padding: 8px;
  padding-bottom: 0;
}

.item-text {
  display: block;

  .item-bold-text {
    font-weight: 700;
  }
}
.item-description-wrapper {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .item-description {
    font-size: 0.85rem;
  }

  &:hover {
    overflow: visible;
  }
}

.item-wrapper {
  border: 1px solid #a3a3a3;
  border-bottom: none;
  padding: 2px 10px;
  height: 48px;

  &:last-child {
    border-bottom: 1px solid #a3a3a3;
  }

  &:nth-child(odd) {
    background-color: lightblue;
  }
}
</style>
